import gsap from 'gsap';
import { twig } from 'twig';

import DetectController from '../../controllers/detect';

import App from '../../app';

import { parseHydration } from '../../helpers';

import assetTemplate from '../../../../bits/asset/template.twig';
import projectsItemTemplate from '../../../../modules/projects/item.twig';
import projectsFilterTemplate from '../../../../modules/projects/filter.twig';

export default class Projects {

	el = {};
	categories = {};

	active = 'all';
	activeIndex = 0;

	isDesktop;

	timelineIn;
	timelineOut;

	constructor({ container }) {
		this.el = {
			container,
			projectAssetsWrap: container.querySelector('.projects__assets ul'),
			projectTop: container.querySelectorAll('.projects__top'),
			projectCategories: container.querySelector('.projects__filter'),
			projectBody: container.querySelector('.projects__body ul'),
			close: container.querySelectorAll('[data-projects-close]'),
			opens: document.querySelectorAll('[data-projects-open]')
		};

		this.isDesktop = DetectController.isDesktop;

		this.data = parseHydration(container);
		this.length = this.data[0].length;

		this.mapCategories();
		this.renderCategories();
		this.renderItems();

		this.el.projectItems = this.el.container.querySelectorAll('.projects__item');
		this.el.projectFilters = this.el.container.querySelectorAll('.projects__filter li');
		this.el.projectAssets = this.el.container.querySelectorAll('.projects__assets li');

		this.addEventListeners();
	}

	addEventListeners() {
		for (const open of this.el.opens) {
			open.addEventListener('click', this.#onOpenClick);
		}
	}

	removeEventListeners() {
		for (const open of this.el.opens) {
			open.removeEventListener('click', this.#onOpenClick);
		}
	}

	addOverlayListeners() {
		for (const item of this.el.projectItems) {
			item.addEventListener('click', this.#onLinkClick);
			item.addEventListener('mouseenter', this.#onLinkMouseEnter);
			item.addEventListener('mouseleave', this.#onLinkMouseLeave);
		}

		for (const filter of this.el.projectFilters) {
			filter.addEventListener('click', this.#onFilterClick);
		}

		for (const close of this.el.close) {
			close.addEventListener('click', this.#onCloseClick);
		}

		this.el.projectBody.addEventListener('mouseleave', this.#onBodyMouseLeave);
	}

	removeOverlayListeners() {
		for (const item of this.el.projectItems) {
			item.removeEventListener('click', this.#onLinkClick);
			item.removeEventListener('mouseenter', this.#onLinkMouseEnter);
			item.removeEventListener('mouseleave', this.#onLinkMouseLeave);
		}

		for (const filter of this.el.projectFilters) {
			filter.removeEventListener('click', this.#onFilterClick);
		}

		for (const close of this.el.close) {
			close.removeEventListener('click', this.#onCloseClick);
		}

		this.el.projectBody.removeEventListener('mouseleave', this.#onBodyMouseLeave);
	}

	#onFilterClick = (e) => {
		e.preventDefault();

		const { currentTarget } = e;
		const wasActive = this.el.container.querySelector('.projects__filter li.is-active');

		if (wasActive === currentTarget) return;

		this.removeOverlayListeners();
		this.clearList();

		if (wasActive) wasActive.classList.remove('is-active');
		currentTarget.classList.add('is-active');

		this.active = currentTarget.children[0].dataset.value;

		this.renderItems();

		this.el.projectItems = this.el.container.querySelectorAll('.projects__item');
		this.el.projectFilters = this.el.container.querySelectorAll('.projects__filter li');
		this.el.projectAssets = this.el.container.querySelectorAll('.projects__assets li');

		this.addOverlayListeners();

		this.el.container.classList.remove('is-filtering');
		this.el.container.classList.add('is-filtering');
	}

	#onOpenClick = () => {
		this.show();
	}

	#onCloseClick = () => {
		this.hide();
	}

	#onLinkClick = () => {
		this.hide();
	}

	#onLinkMouseEnter = (e) => {
		this.el.container.classList.remove('is-filtering');
		this.activeIndex = [...this.el.projectItems].indexOf(e.currentTarget);
		this.el.projectAssets[this.activeIndex].classList.add('is-active');
	}

	#onLinkMouseLeave = (e) => {
		const wasActive = [...this.el.projectItems].indexOf(e.currentTarget);
		this.el.projectAssets[wasActive].classList.remove('is-active');
	}

	#onBodyMouseLeave = () => {
		this.el.projectAssets[this.activeIndex].classList.add('is-active');
	}

	clearList() {
		App.destroy(this.el.projectBody);
		this.el.projectBody.innerHTML = '';
		this.el.projectAssetsWrap.innerHTML = '';
	}

	mapCategories() {
		this.categories = {};
		for (let i = 0, l = this.length; i < l; ++i) {
			for (const category of this.data[0][i].categoriesProjects) {
				if (!this.categories[category.slug]) {
					this.categories[category.slug] = {
						title: category.title,
						items: [i]
					};
				} else {
					this.categories[category.slug].items.push(i);
				}
			}
		}
	}

	renderCategories() {
		this.el.projectCategories.innerHTML = '';
		const all = document.createElement('li');
		all.classList.add('is-active');
		all.innerHTML = twig({ data: projectsFilterTemplate }).render({ value: 'all', label: 'All Projects' });
		this.el.projectCategories.appendChild(all);
		for (const slug in this.categories) {
			const li = document.createElement('li');
			li.innerHTML = twig({ data: projectsFilterTemplate }).render({ value: slug, label: this.categories[slug].title });
			this.el.projectCategories.appendChild(li);
		}
	}

	renderItems() {
		for (let i = 0; i < this.data[0].length; ++i) {
			const item = this.active !== 'all' ? this.data[0][this.categories[this.active].items[i]] : this.data[0][i];

			if (item) {
				item.index = i + 1;
				item.partnerItems = this.data[1]; // eslint-disable-line

				const newItem = document.createElement('li');
				const newAsset = document.createElement('li');

				if (i === 0) {
					newAsset.classList.add('is-active');
				}

				newItem.classList.add('projects__item');
				newItem.innerHTML = twig({ data: projectsItemTemplate }).render(item);
				newAsset.innerHTML = twig({ data: assetTemplate }).render(item.assetFeatured.length ? item.assetFeatured[0] : { width: 495, height: 742 });

				this.el.projectBody.appendChild(newItem);
				this.el.projectAssetsWrap.appendChild(newAsset);
			}
		}

		App.apply(this.el.projectBody, this.uri);
		App.refresh(true);
	}

	show() {
		App.freeze();
		App.dim();

		this.addOverlayListeners();

		const ease = 'expo.out';

		this.timelineIn = gsap.timeline({
			delay: this.isDesktop ? 0 : 0
		});
		this.timelineIn
			.set(this.el.container, {
				display: 'block',
				zIndex: 'var(--z-menu)'
			}, 'start')
			.fromTo(this.el.container, {
				autoAlpha: 0
			}, {
				ease: this.isDesktop ? 'expo.inOut' : 'expo.out',
				autoAlpha: 1,
				duration: this.isDesktop ? 0.75 : 0.5,
				transformOrigin: 'center'
			}, 'start');

		if (this.isDesktop) {
			this.timelineIn
				.fromTo(this.el.container, {
					scale: 0.95
				}, {
					ease: 'expo.inOut',
					scale: 1,
					duration: 1,
					transformOrigin: 'center'
				}, 'start')
				.fromTo(this.el.projectTop, {
					autoAlpha: 0
				}, {
					ease,
					autoAlpha: 1,
					duration: 1.25,
				}, 'start+=0.4')
				.fromTo(this.el.projectItems, {
					y: 40,
					autoAlpha: 0
				}, {
					ease,
					y: 0,
					autoAlpha: 1,
					duration: 1.5,
					stagger: 0.1
				}, 'start+=0.5');
		}
	}

	hide() {
		App.thaw();
		App.undim();

		this.removeOverlayListeners();

		this.el.container.classList.remove('is-filtering');

		if (this.timelineIn) {
			this.timelineIn.kill();
			this.timelineIn = null;
		}

		this.timelineOut = gsap.timeline({
			onComplete: () => {
				this.timelineOut.kill();
				this.timelineOut = null;
			}
		});

		this.timelineOut
			.fromTo(this.el.container, {
				autoAlpha: 1,
			}, {
				ease: 'expo.out',
				autoAlpha: 0,
				duration: 0.35,
				transformOrigin: 'center'
			})
			.set(this.el.container, {
				display: 'none',
				zIndex: '-1'
			});
	}

	destroy() {
		this.removeEventListeners();
	}

}
